import { render, staticRenderFns } from "./Lgx266206478128381952.vue?vue&type=template&id=4cdc5d5a&"
import script from "./Lgx266206478128381952.vue?vue&type=script&lang=js&"
export * from "./Lgx266206478128381952.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports